/*
  Guardian Protection Plan — popup, cart drawer grouping, and quantity sync.
  Loaded by Snippets/warranty-popup.liquid.
*/
(function () {

  const originalFetch = window.fetch;

  const warrantyTiers = [
    { from: 50.01,    to: 150.00,    handle: "guardian-protection-plan-copy" },   // $49.99
    { from: 150.01,   to: 250.00,    handle: "guardian-protection-plan" },        // $59.99
    { from: 250.01,   to: 299.99,    handle: "guardian-protection-plan-1" },      // $69.99
    { from: 300.00,   to: 449.99,    handle: "guardian-protection-plan-2" },      // $99.99
    { from: 450.00,   to: 499.99,    handle: "guardian-protection-plan-3" },      // $109.99
    { from: 500.00,   to: 650.00,    handle: "guardian-protection-plan-4" },      // $129.99
    { from: 650.01,   to: 750.00,    handle: "guardian-protection-plan-copy-1" }, // $149.99
    { from: 750.01,   to: 850.00,    handle: "guardian-protection-plan-5" },      // $169.99
    { from: 850.01,   to: 999.99,    handle: "guardian-protection-plan-copy-2" }, // $179.99
    { from: 1000.00,  to: 1250.00,   handle: "guardian-protection-plan-copy-3" }, // $199.99
    { from: 1250.01,  to: 1500.00,   handle: "guardian-protection-plan-6" },      // $229.99
    { from: 1500.01,  to: 1750.00,   handle: "guardian-protection-plan-7" },      // $249.99
    { from: 1750.01,  to: 2000.00,   handle: "guardian-protection-plan-8" },      // $269.99
    { from: 2000.01,  to: 3500.00,   handle: "guardian-protection-plan-9" },      // $299.99
    { from: 3500.01,  to: 5000.00,   handle: "guardian-protection-plan-10" },     // $329.99
    { from: 5000.01,  to: 7000.00,   handle: "guardian-protection-plan-11" },     // $499.99
    { from: 7000.01,  to: 10000.00,  handle: "guardian-protection-plan-12" },     // $699.99
    { from: 10000.01, to: 999999.99, handle: "guardian-protection-plan-13" },     // $799.99
  ];

  // Products in these collections never get offered Guardian.
  // Values must match each collection's URL handle exactly
  // (the part after /collections/ in the storefront URL).
  // Don't add promo/sale collections here — they can mix in furniture.
  const excludedCollectionHandles = [
    "appliances",
    "electronics",
    "furniture-sleep-bedding-mattresses",
    "furniture-sleep-bedding-bases",
    "furniture-sleep-bedding-bedding",
  ];

  const ROW_SELECTOR = 'li[id^="CartDrawer-Item-"]';

  async function loadExcludedProductIds() {
    const ids = new Set();
    for (const handle of excludedCollectionHandles) {
      let page = 1;
      while (true) {
        const res = await originalFetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
        if (!res.ok) break;
        const data = await res.json();
        const products = data.products || [];
        if (products.length === 0) break;
        products.forEach(p => ids.add(p.id));
        if (products.length < 250) break;
        page++;
      }
    }
    return ids;
  }
  const excludedProductIdsPromise = loadExcludedProductIds();

  const variantCache = {};

  function findTier(price) {
    return warrantyTiers.find(t => price >= t.from && price <= t.to);
  }

  function isWarrantyHandle(handle) {
    return warrantyTiers.some(t => t.handle === handle);
  }

  async function getProductData(handle) {
    if (variantCache[handle]) return variantCache[handle];
    const res = await originalFetch(`/products/${handle}.js`);
    const product = await res.json();
    variantCache[handle] = product;
    return product;
  }

  const wait = (ms) => new Promise(r => setTimeout(r, ms));

  function requestDrawerRefresh() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  }

  function needsGrouping() {
    return !!document.querySelector(`#CartDrawer ${ROW_SELECTOR}:not([data-guardian-grouped])`);
  }

  function rowMatchesItem(row, item) {
    const links = row.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return true;
    return Array.from(links).some(a => {
      const path = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      return path.endsWith(`/products/${item.handle}`);
    });
  }

  // Groups each Guardian line under its furniture row and injects the
  // add-on checkbox for qualifying items without a plan. Returns false if
  // the drawer DOM doesn't match the cart yet (mid-render), so it can retry.
  async function groupWarrantyItemsAndInjectCheckboxes() {
    const anyItemRow = document.querySelector(`#CartDrawer ${ROW_SELECTOR}`);
    if (!anyItemRow) return true;
    const list = anyItemRow.parentElement;

    const cartRes = await originalFetch('/cart.js', { cache: 'no-store' });
    const cart = await cartRes.json();

    if (!list.isConnected) return false;
    const rows = Array.from(list.querySelectorAll(ROW_SELECTOR));
    if (rows.length !== cart.items.length) return false;
    for (let i = 0; i < rows.length; i++) {
      if (!rowMatchesItem(rows[i], cart.items[i])) return false;
    }

    // Verified. Mark rows first so the observer ignores our moves below.
    rows.forEach(r => { r.dataset.guardianGrouped = '1'; });

    // Remove only OUR previously injected rows.
    list.querySelectorAll('.warranty-addon-row').forEach(el => el.remove());

    const excludedIds = await excludedProductIdsPromise;

    // furniture variant_id -> index of its linked warranty row
    const warrantyIndexByVariant = {};
    cart.items.forEach((item, idx) => {
      const linked = item.properties && item.properties._guardian_for;
      if (linked) warrantyIndexByVariant[String(linked)] = idx;
    });

    const moved = new Set();
    const fragment = document.createDocumentFragment();

    for (let idx = 0; idx < cart.items.length; idx++) {
      if (moved.has(idx)) continue;
      const item = cart.items[idx];
      const row = rows[idx];
      if (isWarrantyHandle(item.handle)) continue; // placed via its furniture partner

      fragment.appendChild(row);
      moved.add(idx);

      const warrantyIdx = warrantyIndexByVariant[String(item.variant_id)];
      if (warrantyIdx !== undefined) {
        const warrantyRow = rows[warrantyIdx];
        warrantyRow.classList.add('wt-cart_item--warranty-subitem');
        // Quantity is auto-synced to the furniture item, so hide the stepper.
        warrantyRow.querySelectorAll(
          'quantity-counter, [class*="counter"], input[type="number"]'
        ).forEach(el => { el.style.display = 'none'; });
        // Divider above the warranty row is the furniture row's border-bottom.
        row.style.borderBottom = 'none';
        fragment.appendChild(warrantyRow);
        moved.add(warrantyIdx);
      } else if (!excludedIds.has(item.product_id)) {
        const tier = findTier(item.price / 100);
        if (tier) {
          row.style.borderBottom = 'none';
          fragment.appendChild(buildAddonCheckboxRow(item, tier));
        }
      }
    }

    // Safety net: anything not placed above still gets appended.
    for (let idx = 0; idx < rows.length; idx++) {
      if (!moved.has(idx)) fragment.appendChild(rows[idx]);
    }

    list.appendChild(fragment);
    return true;
  }

  // Single-flight wrapper with retry: if the drawer is mid-render, wait
  // and try again instead of acting on a partial DOM.
  let isGrouping = false;
  let groupQueued = false;

  async function groupWhenStable() {
    if (isGrouping) { groupQueued = true; return; }
    isGrouping = true;
    try {
      for (let attempt = 0; attempt < 6; attempt++) {
        if (await groupWarrantyItemsAndInjectCheckboxes()) break;
        await wait(250);
      }
    } catch (e) {
      console.error('Guardian grouping failed', e);
    }
    isGrouping = false;
    if (groupQueued) {
      groupQueued = false;
      if (needsGrouping()) groupWhenStable();
    }
  }

  // Watches the stable #CartDrawer parent (its content is replaced
  // wholesale on each theme render). Reacts ONLY when new, unhandled cart
  // rows appear; debounced so a large render settles first.
  function watchCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    let debounceTimer = null;
    new MutationObserver(() => {
      if (!needsGrouping()) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (needsGrouping()) groupWhenStable();
      }, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }

  async function addWarranty(tierHandle, furnitureVariantId, quantity) {
    const product = await getProductData(tierHandle);
    return originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: product.variants[0].id,
          quantity: quantity,
          properties: { _guardian_for: String(furnitureVariantId) }
        }]
      })
    });
  }

  function buildAddonCheckboxRow(item, tier) {
    const li = document.createElement('li');
    li.className = 'warranty-addon-row wt-cart_item--warranty-subitem';

    const label = document.createElement('label');
    label.className = 'warranty-addon-row__label';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';

    const logo = document.createElement('img');
    logo.className = 'warranty-addon-row__logo';
    logo.alt = 'Guardian';
    logo.loading = 'lazy';

    const text = document.createElement('span');
    text.textContent = 'Add Guardian Protection Plan';

    getProductData(tier.handle).then(product => {
      text.textContent = `Add Guardian Protection Plan — $${(product.variants[0].price / 100).toFixed(2)}`;
      if (product.featured_image) logo.src = product.featured_image;
    });

    checkbox.addEventListener('change', async (e) => {
      // This row lives inside the theme's <cart-drawer-items>, which treats
      // every bubbling "change" as a quantity edit. Without this, ticking the
      // box sends a bad /cart/change (no line index) → 400 → cart.js crash.
      e.stopPropagation();
      if (!checkbox.checked) return;
      checkbox.disabled = true;
      const res = await addWarranty(tier.handle, item.variant_id, item.quantity);
      if (res.ok) {
        requestDrawerRefresh();
      } else {
        console.error('Guardian warranty add-to-cart failed', await res.text());
        checkbox.checked = false;
        checkbox.disabled = false;
      }
    });

    label.appendChild(checkbox);
    label.appendChild(logo);
    label.appendChild(text);
    li.appendChild(label);
    return li;
  }

  const overlay   = document.getElementById('warranty-popup-overlay');
  const itemEl    = document.getElementById('warranty-popup-item');
  const priceEl   = document.getElementById('warranty-popup-price');
  const addBtn    = document.getElementById('warranty-popup-add');
  const skipBtn   = document.getElementById('warranty-popup-skip');
  const closeBtn  = document.getElementById('warranty-popup-close');

  let currentTier = null;
  let currentFurnitureVariantId = null;
  let currentFurnitureQuantity = 1;

  async function openPopup(itemTitle, tier, furnitureVariantId, furnitureQuantity) {
    currentTier = tier;
    currentFurnitureVariantId = furnitureVariantId;
    currentFurnitureQuantity = furnitureQuantity;
    itemEl.textContent = `For your ${itemTitle}`;
    overlay.hidden = false;
    const product = await getProductData(tier.handle);
    priceEl.textContent = `Add protection plan — $${(product.variants[0].price / 100).toFixed(2)}`;
  }

  function closePopup() {
    overlay.hidden = true;
    currentTier = null;
    currentFurnitureVariantId = null;
    currentFurnitureQuantity = 1;
  }

  closeBtn.addEventListener('click', closePopup);
  skipBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closePopup(); });

  addBtn.addEventListener('click', async () => {
    if (currentTier) {
      const res = await addWarranty(currentTier.handle, currentFurnitureVariantId, currentFurnitureQuantity);
      if (res.ok) {
        requestDrawerRefresh();
      } else {
        console.error('Guardian warranty add-to-cart failed', await res.text());
      }
    }
    closePopup();
  });

  // Keeps each Guardian line's quantity equal to its furniture item's
  // (and removes it if the furniture item is gone).
  async function reconcileWarrantyLines() {
    const cartRes = await originalFetch('/cart.js', { cache: 'no-store' });
    const cart = await cartRes.json();
    const updates = {};
    cart.items.forEach(item => {
      const linkedVariantId = item.properties && item.properties._guardian_for;
      if (!linkedVariantId) return;
      const furnitureItem = cart.items.find(
        i => String(i.variant_id) === String(linkedVariantId)
      );
      const targetQty = furnitureItem ? furnitureItem.quantity : 0;
      if (item.quantity !== targetQty) updates[item.key] = targetQty;
    });
    if (Object.keys(updates).length > 0) {
      await originalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      requestDrawerRefresh();
    }
  }

  // Passive listener on the page's cart requests: reads responses, never
  // alters them. Our own requests use originalFetch and aren't seen here.
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

    if (url && url.includes('/cart/add')) {
      response.clone().json().then(async data => {
        const item = Array.isArray(data.items) ? data.items[0] : data;
        if (!item || isWarrantyHandle(item.handle)) return;
        const excludedIds = await excludedProductIdsPromise;
        if (excludedIds.has(item.product_id)) return;
        const tier = findTier(item.price / 100);
        if (tier) openPopup(item.product_title, tier, item.variant_id, item.quantity);
      }).catch(() => {});
    }

    if (url && (url.includes('/cart/change') || url.includes('/cart/update'))) {
      reconcileWarrantyLines().catch(() => {});
    }

    return response;
  };

  watchCartDrawer();
  if (needsGrouping()) groupWhenStable();
})();